/**
 * Format an ISO date / DD-MM-YYYY / DD/MM/YYYY → "30 Sep 2022" (Indian convention).
 * Returns the original string if parse fails so dates from MCA stay readable.
 */
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function formatIndianDate(value) {
  if (!value) return "";
  const s = String(value).trim();
  if (!s) return "";

  // ISO YYYY-MM-DD
  let m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (m) {
    const [, y, mo, d] = m;
    return `${parseInt(d, 10)} ${MONTHS[parseInt(mo, 10) - 1] || mo} ${y}`;
  }
  // DD/MM/YYYY or DD-MM-YYYY
  m = s.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{2,4})$/);
  if (m) {
    let [, d, mo, y] = m;
    if (y.length === 2) y = `20${y}`;
    return `${parseInt(d, 10)} ${MONTHS[parseInt(mo, 10) - 1] || mo} ${y}`;
  }
  // ISO with time
  const d = new Date(s);
  if (!isNaN(d.getTime())) {
    return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
  }
  return s;
}

/**
 * Convert ISO (YYYY-MM-DD) to DD-MM-YYYY for display.
 * Returns the original string if it doesn't look like ISO, so dates like
 * "30-09-2022" pass through unchanged.
 */
export function isoToDmy(value) {
  if (!value) return "";
  const s = String(value).trim();
  const m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (m) {
    const [, y, mo, d] = m;
    return `${d.padStart(2, "0")}-${mo.padStart(2, "0")}-${y}`;
  }
  // Already DD-MM-YYYY or DD/MM/YYYY → normalise to DD-MM-YYYY
  const m2 = s.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{2,4})$/);
  if (m2) {
    let [, d, mo, y] = m2;
    if (y.length === 2) y = `20${y}`;
    return `${d.padStart(2, "0")}-${mo.padStart(2, "0")}-${y}`;
  }
  return s;
}

/**
 * Convert DD-MM-YYYY or DD/MM/YYYY → ISO YYYY-MM-DD. Returns "" if invalid.
 * Passes through already-ISO strings.
 */
export function dmyToIso(value) {
  if (!value) return "";
  const s = String(value).trim();
  if (!s) return "";
  // Already ISO
  if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(s)) {
    const [y, mo, d] = s.split("-");
    return `${y}-${mo.padStart(2, "0")}-${d.padStart(2, "0")}`;
  }
  const m = s.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{2,4})$/);
  if (!m) return "";
  let [, d, mo, y] = m;
  if (y.length === 2) y = `20${y}`;
  // Validate ranges
  const di = parseInt(d, 10);
  const mi = parseInt(mo, 10);
  if (di < 1 || di > 31 || mi < 1 || mi > 12) return "";
  return `${y}-${String(mi).padStart(2, "0")}-${String(di).padStart(2, "0")}`;
}
